import MiniAppDriver from 'driver-miniapp';
export default MiniAppDriver;